import { useEffect, useState } from "react";
import { useGetContractModelsQuery } from "../api/workContractApiSlice";
import Loading from "components/commons/Loading";
import { useTranslation } from "react-i18next";
import WorkingWeek from "../../../test/WorkingWeek";

export default function WorkerContractCard(
    {
        workerContract,
        onValueChanged = (payload) => { }
    }
) {

    const [t] = useTranslation(["global", "absenceReport"])

    const [workerClassGuid, setWorkerClassGuid] = useState(workerContract?.workerClass?.guid || null)
    const [employmentDate, setEmploymentDate] = useState(workerContract?.date || null)
    const [workingWeek, setWorkingWeek] = useState(workerContract?.week)

    const {
        data: contractModels,
        isLoading: contractModelsIsLoading,
        isFetching: contractModelsIsFetching,
        isSuccess: contractModelsIsSuccess,
        isError: contractModelsIsError,
        error: contractModelsError,
        refetch
    } = useGetContractModelsQuery()


    let baseHours


    const handleWorkerClassSelect = (e) => {
        setWorkerClassGuid(e.target.value)
    }

    const handleEmploymentDateChange = (e) => {

        let dateInputValue = e.target.value
        // let convertedValue = dateInputValue.split("-").reverse().join("-")
        // console.log("Date converted from: "+ dateInputValue + " --> " + convertedValue)
        setEmploymentDate(dateInputValue)
    }

    function reverseDate(date) {
        if (date != null)
            return date.split("-").reverse().join("-")
    }

    if (contractModelsIsSuccess && workerClassGuid) {
        const matchingContractModel = contractModels.find(contractModel =>
            contractModel.workerClasses.some(workerClass => workerClass.guid === workerClassGuid || workerClass.guid === workerContract?.workerClass?.guid)
        );

        baseHours = matchingContractModel.baseHours || null;
    }


    useEffect(() => {
        if (contractModelsIsSuccess) {
            let payload
            if (workerContract != null) {
                payload = {
                    workerClass: workerClassGuid
                        ? contractModels
                            .flatMap(contractModel => contractModel.workerClasses) // Combina tutti i workerClasses in un unico array
                            .find(item => item.guid == workerClassGuid) // Cerca il workerClass corrispondente
                        : (workerContract.workerClass ? workerContract.workerClass : null),
                    employmentDate: employmentDate ? employmentDate : workerContract.employmentDate,
                    week: workingWeek ? workingWeek : workerContract.week
                }
            } else {
                payload = {
                    workerClass: null,
                    employmentDate: employmentDate,
                    week: workingWeek
                }

            }

            onValueChanged(payload)
        }

    }, [workerClassGuid, employmentDate, workingWeek, contractModelsIsSuccess])


    let content;
    var fixedHours

    if (contractModelsIsLoading) {
        content = <Loading />
    } else {

        if (contractModelsIsSuccess && workerContract != null) {
            fixedHours = workerContract.week?.map(weekDay =>
                weekDay.slots.map(slot => (toMins(slot.end) - toMins(slot.start)) / 60)
                    .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
            ).reduce((accumulator, currentValue) => accumulator + currentValue, 0)
        }

        if (fixedHours == null) {
            fixedHours = 0
        }

        content = (
            contractModelsIsSuccess && workerContract != null &&
            <>
                <div className="row">
                    {/* <form onSubmit={() => { }}> */}
                    <div className="row">
                        <h4 className="mb-3"><i className="fa-solid fa-briefcase"></i> {t("absenceReport:menu.work_contract")}</h4>
                        <div className=" col-5 ">
                            <div className="row">
                                <label htmlFor="lastName">{t("absenceReport:property.employment_date")}</label>
                                <div className="col-md-4 mb-3">
                                    <input className=" p-2" type="date" id="start" name="trip-start" value={workerContract.employmentDate} onChange={handleEmploymentDateChange} required />
                                </div>
                            </div>

                            <div className="col-md-6 mb-3">
                                <label htmlFor="employeeFirstName">{t("absenceReport:property.contractual_level")}</label>
                                <select className="form-select" aria-label="Default select example" onChange={handleWorkerClassSelect} value={workerContract.workerClass ? workerContract.workerClass.guid : null} required>
                                    <option value="">{t("absenceReport:helper.select_level")}</option>
                                    {
                                        contractModels.map((contractModel, index) => (
                                            <>
                                                {
                                                    contractModel.workerClasses.map(workerClass => (
                                                        <option key={workerClass.guid} value={workerClass.guid}>{workerClass.name}</option>
                                                    ))
                                                }
                                                {index < contractModels.length - 1 && <option disabled key={index}>──────────</option>}
                                            </>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className="row">
                                <label htmlFor="lastName">{t("absenceReport:property.weekly_hours")}</label>
                                <div className="col-md-4 mb-3">
                                    <h5>
                                        <i className="fa-solid fa-clock mx-2"></i>
                                        {fixedHours}
                                    </h5>
                                    <div className="invalid-feedback">
                                        Valid last name is required.
                                    </div>
                                </div>
                                <div className="col-md-4 mb-3 text-muted">
                                    <span><b>{Math.round((fixedHours / baseHours) * 100)} %</b> <br /><small> {t("absenceReport:helper.base_n_hours", { hours: baseHours })}</small></span>
                                </div>
                            </div>
                        </div>
                        <div className=" col-7">
                            <label htmlFor="lastName">{t("absenceReport:property.working_time")}</label>
                            <div className="card bg-dark p-3">
                                <WorkingWeek workerWeek={workerContract.week} onWeekChange={(week) => { setWorkingWeek(week) }} />
                            </div>
                        </div>
                    </div>
                </div >
            </>
        )
    }

    return content

}


function toMins(time) {
    var parts = time.split(':');
    return (+parts[0] * 60 + +parts[1]) || 0;
}